import { Individu } from '@/models/Individu';
import { Autorisations } from '@/models/Autorisations';
import { HistoScolarite } from '@/models/HistoScolarite';
import { NiveauScolaireDocument } from '@/models/NiveauScolaireDocument';
import { Ville } from '@/models/Ville';
import { EtablissementScolaireDocument } from '@/models/EtablissementScolaireDocument';
import { ClasseScolaireDocument } from '@/models/ClasseScolaireDocument';
import { EnseignantScolaireDocument } from '@/models/EnseignantScolaireDocument';
import { AnneeScolaireDocument } from '@/models/AnneeScolaireDocument';
import { EtablissementScolaireNiveauDocument } from '@/models/EtablissementScolaireNiveauDocument';
import { ClasseScolaireNiveauDocument } from '@/models/ClasseScolaireNiveauDocument';
import { ClasseScolaireEnseignantDocument } from '@/models/ClasseScolaireEnseignantDocument';

export interface IndividuState {
    listIndividus: Array<Individu>
    filtredListe: Array<Individu>
    individu: Individu,
    listEcoles: Array<EtablissementScolaireDocument>,
    listClasses: Array<ClasseScolaireDocument>,
    listInstits: Array<EnseignantScolaireDocument>,
    listHisto: Array<HistoScolarite>,
    listNiveau: Array<NiveauScolaireDocument>,
    listAutorisations: Array<Autorisations>,
    currentAnneeScolaire : AnneeScolaireDocument,
    listEtablissementScolaireNiveau : Array<EtablissementScolaireNiveauDocument>,
    listClasseScolaireNiveau : Array<ClasseScolaireNiveauDocument>,
    listClasseScolaireEnseignant : Array<ClasseScolaireEnseignantDocument>,
    filtrePrenom : boolean,
    listVille: Array<Ville>,
    filtreIndividusJour: boolean,
    filtreAge: {
        actif: boolean,
        value: any
    }
    filtreEcoles: {
        actif: boolean,
        value: any
    }
    filtreClasses: {
        actif: boolean,
        value: any
    }
    filtreNiveau: {
        actif: boolean,
        value: any
    }
    filtreInstit: {
        actif: boolean,
        value: any
    }
    filtreVille: {
        actif: boolean,
        value: any
    }
    filtrePointage: {
        actif: boolean,
        value: any
    }
    filtreGroupes: {
        actif: boolean,
        value: any
    }
    filtreRegim: {
        actif: boolean,
        value: any
    }
}
export enum INDIVIDUS_STORE {
    /* Mutations */
    SET_LIST_INDIVIDUS = "setListIndividus",
    SET_LIST_INSCRIPTIONS = "setListInscriptions",
    SET_FILTRED_LIST_INDIVIDUS = "setFiltredListIndividus",
    SET_INDIVIDU = "setIndividu",
    SET_FILTRE_ACTIFS = "setFiltreActifs",
    SET_FILTRE_CLOSE = "setFiltreClose",
    SET_LIST_ECOLES = "setListEcoles",
    SET_LIST_CLASSES = "setListClasses",
    SET_LIST_INSTITS = "setListInstits",
    SET_LIST_HISTO = "setListHisto",
    SET_LIST_NIVEAU = "setListNiveau",
    SET_LIST_AUTORISATIONS = "setListAutorisations",
    SET_LIST_VILLE = "setListVille",
    SET_CURRENT_ANNEE_SCOLAIRE = "setCurrentAnneeScolaire",
    SET_ETABLISSEMENT_SCOLAIRE_NIVEAU="setEtablissementScolaireNiveau",
    SET_CLASSE_SCOLAIRE_NIVEAU = "setClasseScolaireNiveau",
    SET_CLASSE_SCOLAIRE_ENSEIGNANT = "setClasseScolaireEnseignant",
    SET_INDIVIDU_DU_JOUR = "setIndividuDuJour"
}